import { render, staticRenderFns } from "./errorMessage.vue?vue&type=template&id=92965d88&scoped=true"
import script from "./errorMessage.vue?vue&type=script&lang=js"
export * from "./errorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92965d88",
  null
  
)

export default component.exports